import React from 'react';
import { useOpenState } from '../../../hooks/useSelect/useOpenState';
export const useValue = ({ defaultValue, value: valueProps }) => {
    const [innerValue, setInnerValue] = React.useState(defaultValue || []);
    const value = valueProps || innerValue;
    const uncontrolled = !valueProps;
    const selected = React.useMemo(() => value.reduce((acc, value) => {
        acc[value] = true;
        return acc;
    }, {}), [value]);
    return {
        selected,
        value,
        /**
         * Available only if `uncontrolled` component valiant
         */
        setInnerValue: uncontrolled ? setInnerValue : undefined,
    };
};
export const useTreeSelectSelection = ({ value, setInnerValue, defaultOpen, onClose, onOpenChange, open: openProps, onUpdate, }) => {
    const { toggleOpen, open } = useOpenState({
        defaultOpen,
        onClose,
        onOpenChange,
        open: openProps,
    });
    const handleSingleSelection = React.useCallback((id) => {
        if (!value.includes(id)) {
            const nextValue = [id];
            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(nextValue);
            setInnerValue === null || setInnerValue === void 0 ? void 0 : setInnerValue(nextValue);
        }
        toggleOpen(false);
    }, [value, toggleOpen, onUpdate, setInnerValue]);
    const handleMultipleSelection = React.useCallback((id) => {
        const alreadySelected = value.includes(id);
        const nextValue = alreadySelected
            ? value.filter((iteratedVal) => iteratedVal !== id)
            : [...value, id];
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(nextValue);
        setInnerValue === null || setInnerValue === void 0 ? void 0 : setInnerValue(nextValue);
    }, [value, onUpdate, setInnerValue]);
    const handleClearValue = React.useCallback(() => {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate([]);
        setInnerValue === null || setInnerValue === void 0 ? void 0 : setInnerValue([]);
    }, [onUpdate, setInnerValue]);
    return {
        open,
        toggleOpen,
        handleSingleSelection,
        handleMultipleSelection,
        handleClearValue,
    };
};
